import React from 'react';

export default function RefreshCwIcon02({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M11.08 2.045c-3.424.302-6.527 2.438-8.042 5.535-.448.914-.809 2.015-.804 2.448a.978.978 0 0 0 .586.878c.383.179.766.106 1.086-.205.178-.173.219-.242.292-.501.212-.745.384-1.224.604-1.677A7.906 7.906 0 0 1 6.9 5.847c2.08-1.744 4.995-2.297 7.597-1.443.92.302 1.866.826 2.603 1.443.448.374 1.74 1.689 2.471 2.513l.55.62-2.19.02c-1.63.015-2.22.033-2.304.07a1.146 1.146 0 0 0-.499.446c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.221.079 6.439.079 6.66 0 .221-.079.414-.241.539-.454l.111-.189V3.7l-.109-.186a1.01 1.01 0 0 0-1.742 0l-.109.186L21 5.311l-.02 1.612-.608-.653c-.85-.911-1.681-1.72-2.152-2.093a10.019 10.019 0 0 0-7.14-2.132M1.725 13.04c-.205.048-.449.24-.584.458l-.121.196v6.612l.121.197a.998.998 0 0 0 1.718 0l.121-.197.02-1.614.02-1.615.62.666c1.729 1.856 2.667 2.614 4.06 3.28.62.296 1.269.527 1.945.692.876.214 1.317.263 2.355.263s1.479-.049 2.355-.263a9.99 9.99 0 0 0 6.607-5.295c.324-.662.51-1.153.697-1.84.17-.625.137-.92-.14-1.235-.205-.233-.41-.323-.739-.323-.498 0-.832.268-.98.786-.505 1.767-1.118 2.841-2.246 3.933a7.375 7.375 0 0 1-2.083 1.459 7.994 7.994 0 0 1-8.511-.989c-.384-.31-1.82-1.768-2.531-2.571l-.55-.62 2.21-.02 2.211-.02.192-.113c.756-.444.631-1.561-.202-1.812-.149-.045-.766-.054-3.306-.051-1.718.002-3.185.019-3.259.036'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}
